import React, { Component } from 'react';
import { createBrowserHistory } from 'history';
import { Redux } from '../utils/utilities'
import { store, SessionStore, BudgetStore, ProaStore, FollowupStore, PopStore } from '../store';

export interface IStoreContext{
    history?: any;
    sessionStore: SessionStore;
    budgetStore: BudgetStore;
    proaStore : ProaStore;
    followupStore : FollowupStore;
    popStore : PopStore;
}

const StoreContext = React.createContext({
    history: createBrowserHistory(),
    sessionStore: new SessionStore(),
    budgetStore: new BudgetStore(),
    proaStore : new ProaStore(),
    followupStore: new FollowupStore(),
    popStore: new PopStore()
});

class StoreProvider extends Component<IStoreContext | any>{
    public render(){
        return (
            <StoreContext.Provider value={{
                history : createBrowserHistory(),
                sessionStore: new SessionStore(),
                budgetStore: new BudgetStore(),
                proaStore : new ProaStore(),
                followupStore: new FollowupStore(),
                popStore: new PopStore()
            }}>
                <Redux.Provider store={store}>
                    {this.props.children}
                </Redux.Provider>
            </StoreContext.Provider>
        );
    }
}
export default{
    StoreProvider: StoreProvider,
    StoreContext: StoreContext
}